const templateCurrency = (string, nameReplacement, symbolReplacement) => {
  const templated = string
    .replace(/\{CURRENCY_NAME\}/gi, nameReplacement)
    .replace(/\{CURRENCY_SYMBOL\}/gi, symbolReplacement);
  return templated;
};

const valueOrNull = (value) => {
  return value !== '' ? value : null;
};

const boolValue = (value) => {
  return value === 'true';
};

const webpIfSupported = (image) => {
  return process.browser && Modernizr.webpalpha ? image.replace('.jpg', '.webp') : image;
};

const getAvifImagePath = (image) => {
  return image.replace(/\.(png|jpg|jpeg)/i, '.avif');
};

module.exports = {
  boolValue,
  valueOrNull,
  getAvifImagePath,
  templateCurrency,
  webpIfSupported,
};
